import { FactorDetailsModel } from './factordetails.model';

export class FactorModel {
  num: number;
  id: number;
  price?: number;
  status: number;
  mergeHeaderId?: number;
  discountPercent?: number;
  discountAmount?: number;
  serviceAmount?: number;
  servicePercent?: number;
  taxAmount?: number;
  taxPercent?: number;
  roundedAmount?: number;
  phoneNumber: string;
  fireLevel?: number;
  printAsh?: number;
  branchCode: number;
  description: string;
  transactionNo: string;
  errorCodePay: string;
  errorMessagePay: string;
  merchantIDPay: string;
  terminalIDPay: string;
  paymentTypeCode: number;
  flagPda?: number;
  tableId: string;
  tableName: string;
  customerName: string;
  flag: string;
  pard: number;
  waiterName: string;
  guestQty?: number;
  waiterId?: number;
  time: string;
  sourceFlag: string;
  pdaPrintFlag?: number;
  hasCashPrint?: number;
  tas?: number;
  creationTime: string;
  checked: boolean;
  redirectUrl: string;
  clubCardNo: number;
  usedCredit: number;
  creditUsedPersent: number;
  creditUsedRial: number;
  creditPersent: number;
  credit: number;
  creditPrice?: number;
  factorDetail?: FactorDetailsModel[];
  digitalMenuHeaderId?: number;
  FarsiDate: string;
  isOrderPrint?: number;
  constructor() {
    this.num = 0;
    this.FarsiDate = '';
    this.id = 0;
    this.price = 0;
    this.status = 0;
    this.clubCardNo = null;
    this.creationTime = "";
    this.mergeHeaderId = 0;
    this.discountPercent = 0;
    this.discountAmount = 0;
    this.serviceAmount = 0;
    this.servicePercent = 0;
    this.taxAmount = 0;
    this.taxPercent = 0;
    this.roundedAmount = 0;
    this.phoneNumber = '';
    this.branchCode = 0;
    this.description = '';
    this.transactionNo = '';
    this.errorCodePay = '';
    this.errorMessagePay = '';
    this.merchantIDPay = '';
    this.terminalIDPay = '';
    this.paymentTypeCode = 0;
    this.flagPda = 0;
    this.tableId = '';
    this.tableName = '';
    this.customerName = '';
    this.flag = '';
    this.waiterName = '';
    this.guestQty = null;
    this.waiterId = 0;
    this.time = '';
    this.sourceFlag = '';
    this.pdaPrintFlag = 0;
    this.hasCashPrint = 0;
    this.tas = 0;
    this.factorDetail = [];
    this.checked = false;
    this.creditPrice = null;
    this.digitalMenuHeaderId = null;
  }
}

export class InvoiceModel {
  // شماره فاکتور 
  num: number;
  // مبلغ قابل پرداخت
  price?: number;
  //تخفیف
  discountAmount?: number;
  serviceAmount?: number;
  taxAmount?: number;
  roundedAmount?: number;
  phoneNumber: string;
  description: string;
  //transactionNo: string;
  tableName: string;
  customerName: string;
  waiterName: string;
  // تعداد نفرات
  guestQty?: number;
  time: string;
  creationTime: string;
  // اعتبار باشگاه
  usedCredit: number;
  creditPrice?: number;
  sumQty: number;
  sumPrice: number;
  restaurantName: string;
  farsiDate: string;
  invoiceDetail?: InvoiceDetailsModel[];
  constructor() {
    this.num = 0;
    this.sumQty = 0;
    this.sumPrice = 0;
    this.price = 0;
    this.discountAmount = 0;
    this.serviceAmount = 0;
    this.taxAmount = 0;
    this.roundedAmount = 0;
    this.phoneNumber = '';
    this.description = '';
    //this.transactionNo = '';
    this.tableName = '';
    this.customerName = '';
    this.waiterName = '';
    this.guestQty = 0;
    this.creationTime = '';
    //this.time = '';
    this.invoiceDetail = [];
    this.creditPrice = 0;
    this.farsiDate = '';
    this.usedCredit = 0;

  }
}
export class InvoiceDetailsModel {
  //radif: number;
  // نام کالا
  name: string;
  //unit: string;
  // تعداد
  qty?: number;
  unitPrice: number;
  // توضیحات
  toz: string;
  sumUnitPrice: number;
  constructor() {
    //this.radif = 0;
    this.sumUnitPrice = 0;
    this.name = '';
    //this.unit = '';
    this.qty = 0;
    this.unitPrice = 0;
    this.toz = '';
  }
}
export class PrintInvoiceModel {
  num: number;
  pr: number;
  branchCode: number;
  printTime: string;
}
